<template>
    <div class="bottom-container">
        <div class="top">
            <div class="top-left">
                <!--            <div class="bottomFont"><span>INSTITUTEFOR STEM CELL AND REGENERATION</span></div>-->
                <div><span class="bottomFont1">Institute of Zoology</span></div>
                <div><span class="bottomFont1">Chinese Academy of Sciences</span></div>
                <div class="bottomFontTitle"><span>Guo Lab</span></div>
            </div>
            <div class="top-right">
                <div class="right-img">
                    <!--                                <a href="https://cs8.3dembryo.com/#/home" target="_blank">
                                                        <img src="https://cdn.panda.simuhunluo.top/official/cs8.png" width="82" height="82">
                                                    </a>-->
                    <a href="http://www.ioz.ac.cn/" target="_blank" style="margin-left: 20px">
                        <img src="https://cdn.panda.simuhunluo.top/official/lab.png" width="82" height="82">
                    </a>
                </div>
                <div class="right-text">
                    <div>100101. Beijing. China</div>
                </div>

            </div>
        </div>

        <div class="bottom">
            <span><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025104429号-1</a></span>
            <span> Copyright © 2025 GuoLab.</span>
        </div>


    </div>
</template>

<script>
export default {
    name: 'BottomCom',
}
</script>
<style scoped lang="scss">
@use "src/assets/css/variables.scss" as *;

.bottom-container {
    height: 260px;
    padding-top: 50px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), $white 37%, $green 100%);
    margin-top: 50px;
    padding-left: 10%;
    padding-right: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    .bottom {
        //height: 300px;
        //background-color: red;
    }

    .top {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        .top-left {
            position: relative;
            overflow: hidden;
            text-align: center;
            animation: logoFloat 10s ease-in-out infinite alternate;
            color: #222222BF;
            font-family: 'fontlogo', sans-serif;

            .bottomFont {
                font-size: 15px;
            }

            .bottomFont1 {
                font-size: 20px;
                line-height: 25px;
            }

            .bottomFontTitle {
                font-size: 40px;
                font-weight: 600;

                span {
                    color: #565656;
                    text-shadow: -7px 6px 0px #fffeee96, -3px 3px 3px #BE9A9ABF;
                }
            }
        }

        .top-right {
            height: 100%;
            width: 400px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .right-text {
                height: 100%;
                margin-left: 20px;
                //margin-top: 16px;
                //margin-left: 30%;
                font-size: 20px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: flex-start;

                a {
                    text-decoration: none;
                }
            }
        }
    }


}
</style>
